type Props = {
  children: React.ReactNode;
};

const ProtectedRoute = ({ children }: Props) => {
  // Render a spinner while loading or directly render children if no loading is needed
  return <>{children}</>;
};

export default ProtectedRoute;
